/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
// directives/trim.js
export const vTrim = {
    mounted(el: any, binding: any) {
        const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
        if (!input) return

        input.addEventListener('blur', () => {
            const trimmed = input.value.trim()
            if (input.value !== trimmed) {
                input.value = trimmed
                // 触发 input 事件，同步 v-model
                input.dispatchEvent(new Event('input', { bubbles: true }))
            }
        })
    }
};

export const vHas = {
    mounted(el: any, binding: any) {
        const page_key = el.getAttribute('page-key');
        const str = localStorage.getItem('user_info');
        if (str) {
            const userInfo = JSON.parse(str);
            let ids = [1, 2, 3, 18];
            if (page_key == 'supplier') ids = [1, 2, 3, 133, 134, 135];
            if (ids.includes(userInfo.id)) {
                console.log('允许操作！');
            } else if (binding.value !== userInfo.id) {
                el.parentNode && el.parentNode.removeChild(el);
            }
        }
    }
};